import GetBusinessesRequestModelBase from '../_generated/modelBases/get-businesses-request-model-base';

export default class GetBusinessesRequestModel extends GetBusinessesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
